import React from 'react';
import './Bio.scss';

import { HashLink } from 'react-router-hash-link';

const Bio = () => {
  return (
    <div className='bio-text' id='who-we-are'>
      Insitu-XR is a digital arts collective founded in 2021 by{' '}
      <HashLink scroll={(el) => el.scrollIntoView({ behavior: 'smooth' })} to={'/#elysha-poirier'}>
        Elysha Poirier
      </HashLink>{' '}
      and{' '}
      <HashLink scroll={(el) => el.scrollIntoView({ behavior: 'smooth' })} to={'/#omar-al-faleh'}>
        Omar Al Faleh
      </HashLink>
      , both of whom are Montreal-based new media artists with keen interest in the domains of Augmented Reality,
      Virtual Reality, Urban Storytelling, and spatial media augmentation.
    </div>
  );
};

export default Bio;
